import React from 'react'
import PropTypes from 'prop-types'
import { Header } from 'components/patterns'
import strings from 'utils/strings'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalContent,
  ModalMainContainer,
  ModalCloseButton,
  ModalButton,
} from 'components/patterns/Modal'

import withStyle from './TemplateDiffViewModal.style'

const TemplateDiffViewModal = ({ onClose, diffListTable, domainTitle }) => (
  <Modal data-testid="template-diff-view-modal">
    <ModalHeader>
      <Header type="h2">
        {strings.domain}: {domainTitle}
      </Header>
      <ModalCloseButton onClick={onClose} />
    </ModalHeader>
    <ModalBody>
      <ModalMainContainer>
        <ModalContent>{diffListTable}</ModalContent>
      </ModalMainContainer>
    </ModalBody>
    <ModalFooter data-testid="modal-footer">
      <ModalButton type="secondary" onClick={onClose}>
        {strings.close}
      </ModalButton>
    </ModalFooter>
  </Modal>
)

TemplateDiffViewModal.propTypes = {
  onClose: PropTypes.func,
  diffListTable: PropTypes.element,
  domainTitle: PropTypes.string,
}

export default withStyle(TemplateDiffViewModal)
